import {Link, useParams} from "react-router-dom";
import React, {useState} from "react";
import {BaseScopeModel, DeveloperScopeCardModel} from "../ScopeModel";
import {Card, CardContent, CardHeader, CardTitle} from "../../ui/card";
import {moneyFormatter} from "../../../lib/formatters";
import {AlertCircle, AlertCircleIcon} from "lucide-react";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../../ui/tooltip";


type DeveloperScopeCardProps = {
    scope: DeveloperScopeCardModel
}


/*
* What do we want to see here??
* NUmber of bidders invited.
* Number of bids
*
* */
export function DeveloperScopeCard({scope}: DeveloperScopeCardProps) {
    const {project_id} = useParams<string>();
    return (
        <Card key={scope.id} className="mb-4">
            <CardHeader>
                <CardTitle className="flex justify-between items-center hover:underline">
                    <Link
                        className="text-lg font-semibold"
                        to={`/project/${project_id}/scopes/${scope.id}`}
                    >
                        #{scope.number} - {scope.title}
                    </Link>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-3 gap-4">
                    <div className="text-base mb-2 line-clamp-2">{scope.description}</div>
                    <div className="columns-2 ">
                        <p>Invited Bidders</p>
                        <p className="text-base mb-2">{scope.num_bidders}</p>
                    </div>
                    <div className="columns-2 ">
                        <p>Submitted Bids</p>
                        <p className="text-base mb-2">{scope.num_bids}</p>
                    </div>
                    {scope.lowest_bid ?
                        <div className=" ">
                            <p>Lowest Bid</p>
                            <div className="text-base mb-2">
                                <p>
                                    <Link
                                        className="hover:underline"
                                        to={`/project/${project_id}/bid/${scope.lowest_bid.id}`}>
                                    {moneyFormatter.format(scope.lowest_bid.bid_amount)}
                                </Link>
                                </p>
                                <p>by {scope.lowest_bid.company_name
                                    ?scope.lowest_bid.company_name
                                    : scope.lowest_bid.created_by
                                }</p>
                            </div>
                        </div>
                        :<div>{" "}</div>
                    }
                </div>
            </CardContent>
        </Card>
    );
}


export function DeveloperScopeCardMini({scope}: DeveloperScopeCardProps) {
    const {project_id} = useParams<string>();
    return (
        <div key={scope.id}
             className="flex flex-col rounded-lg shadow p-3 bg-white break-inside-avoid"
        >
            <div className="flex justify-center">
                <Link
                    className="text-lg text-center font-semibold hover:underline py-1"
                    to={`/project/${project_id}/scopes/${scope.id}`}
                >
                    #{scope.number} - {scope.title}
                </Link>

                {scope.num_bidders === 0 &&
                    <div className="inline-flex items-center gap-2 px-3">
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger>
                                    <AlertCircleIcon color={"red"} size={16}/>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>No Invites to this scope</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    </div>
                }
            </div>

            <table className="items-center text-center ">
                <tbody>
                <tr className="text-xs items-center text-center text-gray-700">
                    <td className="text-xs ">Invited</td>
                    <td>Submitted</td>
                    <td>Low</td>
                </tr>
                <tr>
                    <td><p className="text-base mb-2">{scope.num_bidders}</p></td>
                    <td><p className="text-base mb-2">{scope.num_bids}</p></td>
                    <td>
                        {scope.lowest_bid
                            ? <p className="text-base mb-2">
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger>
                                            <Link
                                                className="font-semibold hover:underline"
                                                to={`/project/${project_id}/bids/${scope.lowest_bid.id}`}>
                                                {moneyFormatter.format(scope.lowest_bid.bid_amount)}
                                            </Link>
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>Go to Low Bid</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </p>
                            : <p className="text-base"> n/a</p>
                        }
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}